import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OccupancyEnum } from '@gtpl/shared-models/masters';

export class RackPostionReq {


    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    rackPositionId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    newRackPositionId?: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    saleOrderId?: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;

    @ApiProperty()
    occupancy?: OccupancyEnum;
}